import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const descRegistroImporterSelectors = importerSelectors(
  'descRegistro.importer',
);

export default descRegistroImporterSelectors;
